/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiUpdateCaseAssignedStatusRequest
 */
export interface InternalApiUpdateCaseAssignedStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateCaseAssignedStatusRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateCaseAssignedStatusRequest
     */
    note: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiUpdateCaseAssignedStatusRequest
     */
    draftId?: number;
}

/**
 * Check if a given object implements the InternalApiUpdateCaseAssignedStatusRequest interface.
 */
export function instanceOfInternalApiUpdateCaseAssignedStatusRequest(value: object): value is InternalApiUpdateCaseAssignedStatusRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function InternalApiUpdateCaseAssignedStatusRequestFromJSON(json: any): InternalApiUpdateCaseAssignedStatusRequest {
    return InternalApiUpdateCaseAssignedStatusRequestFromJSONTyped(json, false);
}

export function InternalApiUpdateCaseAssignedStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUpdateCaseAssignedStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'note': json['note'],
        'draftId': json['draftId'] == null ? undefined : json['draftId'],
    };
}

export function InternalApiUpdateCaseAssignedStatusRequestToJSON(json: any): InternalApiUpdateCaseAssignedStatusRequest {
    return InternalApiUpdateCaseAssignedStatusRequestToJSONTyped(json, false);
}

export function InternalApiUpdateCaseAssignedStatusRequestToJSONTyped(value?: InternalApiUpdateCaseAssignedStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'note': value['note'],
        'draftId': value['draftId'],
    };
}

